/*
  Premium look for the product page (assets/sivana-pdp-premium.css). Loaded only when "Premium look"
  is on (sections/sivana-pdp-breadcrumb.liquid).
  Sold-out colors: the swatch app's sold-out circles are hidden, and this writes one quiet line under
  the swatches instead ("Coffee, Olive Night and Navy are sold out."). Each name links to that color's
  page.
*/
(() => {
  function listNames(links) {
    const names = links.map((link) => {
      const a = document.createElement('a');
      a.href = link.getAttribute('href') || '#';
      a.textContent = link.getAttribute('title') || '';
      return a;
    });
    const out = document.createDocumentFragment();
    names.forEach((a, i) => {
      if (i > 0) out.append(i === names.length - 1 ? ' and ' : ', ');
      out.append(a);
    });
    return out;
  }

  function addNote() {
    const container = document.querySelector('.product-information .pl-swatches__container');
    if (!container || container.parentElement?.querySelector('.sivana-soldout-note')) return false;
    const soldOut = [...container.querySelectorAll('.pl-swatches__link--disabled')].filter(
      (link) => !link.querySelector('.pl-swatches__swatch-wrapper--active')
    );
    if (!soldOut.length) return true;
    const note = document.createElement('p');
    note.className = 'sivana-soldout-note';
    note.append(listNames(soldOut), soldOut.length === 1 ? ' is sold out.' : ' are sold out.');
    container.after(note);
    return true;
  }

  // "Color: Fig" from the swatch app becomes two parts, styled like the Size label
  function splitLabel() {
    const label = document.querySelector('.product-information .pl-swatches__label');
    if (!label) return false;
    if (label.querySelector('.sivana-pl-key')) return true;
    const text = label.textContent.trim();
    const at = text.indexOf(':');
    if (at < 0) return true;
    const key = document.createElement('span');
    key.className = 'sivana-pl-key';
    key.textContent = text.slice(0, at + 1);
    const value = document.createElement('span');
    value.className = 'sivana-pl-value';
    value.textContent = ' ' + text.slice(at + 1).trim();
    label.replaceChildren(key, value);
    return true;
  }

  const ready = () => {
    const noted = addNote();
    const split = splitLabel();
    return noted && split;
  };

  // The swatch app draws its row after the page loads; wait for it (stop after 10 seconds)
  if (ready()) return;
  const observer = new MutationObserver(() => {
    if (ready()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 10000);
})();
